import {NotificationBaseModel} from './notification-base.model';

export class SystemNotificationModel extends NotificationBaseModel {
    userLoginIds: number[] = new Array();
    customerNumberIds: number[] = new Array();
}
